import { getUserData } from '../../resources/api-constants'
import { setLoggedUserAuthToken, setLoggedUserData } from './user'
import sso22Axios from '../../utility/sso22Axios'
import { getRequestHeader } from '../../utility/functions'

export const fetchUserData: any = (uuid: string, authToken: string) => async (dispatch: (any: any) => void) => {
    const data = await sso22Axios.get(getUserData(uuid), getRequestHeader(authToken)).then((res) => {
        return res.data
    })
    dispatch(setLoggedUserData(data))
    dispatch(setLoggedUserAuthToken(authToken))
}
